import { render } from "./CustomerDashboard.vue?vue&type=template&id=7a6515ea"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__